module.exports = require("pdfkit");